require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./reviews-olaian-soft-surf-helmet.json") })
        }
      }, "path---reviews-olaian-soft-surf-helmet");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---reviews-olaian-soft-surf-helmet!./.cache/json/reviews-olaian-soft-surf-helmet.json
// module id = 690
// module chunks = 231608221292675